import PropTypes from 'prop-types';

import { getOrganisationResearchersLoading } from 'selectors/organisation';
import { OrgSearchArea } from './OrgSearchArea';

export { SearchBar } from './OrgSearchArea';

/** People tab search bar on the org profile. */
const OrganisationResearchersSearchArea = props => (
  <OrgSearchArea
    {...props}
    loadingSelector={getOrganisationResearchersLoading}
    location='OrganisationResearchersSearch'
  />
);

OrganisationResearchersSearchArea.propTypes = {
  organisation: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
  handleSearch: PropTypes.func.isRequired,
  handleCancel: PropTypes.func,
  loading: PropTypes.bool,
};

export default OrganisationResearchersSearchArea;
